
export enum ApiFeatureStatusCd {
	CANCELLED = 'Cancelled',
	IMPLEMENTED = 'Implemented',
	PENDING = 'Pending',
	SAVED = 'Saved'}

